import { DocumentVersionFieldFragment } from '@client/graphql/__generated__/types';
import { useState } from 'react';

export interface FieldImageData {
  documentVersionField: DocumentVersionFieldFragment;
  image: string;
}

export interface UseFieldImagesReturn {
  fieldsToImages: { [key: string]: string };
  handleImagesLoaded: (images: FieldImageData[]) => void;
}

export const useFieldImages = (): UseFieldImagesReturn => {
  const [fieldsToImages, setFieldsToImages] = useState<{
    [key: string]: string;
  }>({});

  const handleImagesLoaded = (images: FieldImageData[]) => {
    setFieldsToImages(
      images.reduce(
        (acc, image) => {
          acc[image.documentVersionField.mappingKey] = image.image;

          return acc;
        },
        {} as { [key: string]: string }
      )
    );
  };

  return {
    fieldsToImages,
    handleImagesLoaded,
  };
};
